import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import education from "../../assets/images/demos/education.png";
import cart from "../../assets/images/demos/cart.png";
import plate from "../../assets/images/demos/plate.png";
import industry from "../../assets/images/demos/industry.png";
import workers from "../../assets/images/demos/workers.png";
import clinic from "../../assets/images/demos/clinic.png";
import education2 from "../../assets/images/demos/education2.png";
import cart2 from "../../assets/images/demos/cart2.png";
import plate2 from "../../assets/images/demos/plate2.png";
import industry2 from "../../assets/images/demos/industry2.png";
import workers2 from "../../assets/images/demos/workers2.png";
import clinic2 from "../../assets/images/demos/clinic2.png";
import { useTranslation } from 'react-i18next';
import { appConfig } from '../../config';

const Solutions = () => {
    const { t } = useTranslation();

    const [plan, setPlan] = useState(true);
    const toggle = () => setPlan(!plan);

    return (
        <React.Fragment>
            <section className="section bg-light" id="plans">
                <div className="bg-overlay bg-overlay-pattern"></div>
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <div className="text-center mb-5">
                                <h3 className="mb-3 fw-semibold">
                                    {t('t-solutions-head').split('{appName}')[0]}
                                    <span className='text-primary'>{appConfig.appName}</span>
                                    {t('t-solutions-head').split('{appName}')[1]}
                                </h3>
                            </div>
                        </Col>
                    </Row>

                    <Row className="gy-4">
                        <Col lg={4} md={6}>
                            <Card className="plan-box mb-0 h-100">
                                <CardBody className="p-4 m-2">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-1 fw-semibold">
                                                {t('t-solution1')}
                                            </h4>
                                        </div>
                                        <div className="avatar-sm">
                                            <div className="avatar-title bg-light rounded-circle text-primary">
                                                <img src={cart} alt='' className='image-fluid avatar-xs card-logo-dark'></img>
                                                <img src={cart2} alt='' className='image-fluid avatar-xs card-logo-light'></img>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mt-3'>
                                        <p className='text-center fs-17'>
                                            {t('t-solution1-desc').split('{appName}')[0]}
                                            <span className='fw-bold'>{appConfig.appName}</span>
                                            {t('t-solution1-desc').split('{appName}')[1]}
                                        </p>
                                        <div className="mt-4">
                                            <Link to="#" className="btn btn-soft-success w-100">
                                                {t('t-view')}
                                            </Link>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg={4} md={6}>
                            <Card className="plan-box mb-0 h-100">
                                <CardBody className="p-4 m-2 d-flex flex-column">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-1 fw-semibold">
                                                {t('t-solution2')}
                                            </h4>
                                        </div>
                                        <div className="avatar-sm">
                                            <div className="avatar-title bg-light rounded-circle text-primary" style={{ padding: "20px" }}>
                                                <img src={plate} alt='' className='image-fluid avatar-sm card-logo-dark'></img>
                                                <img src={plate2} alt='' className='image-fluid avatar-sm card-logo-light'></img>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mt-3 d-flex flex-column justify-content-between h-100'>
                                        <p className='text-center fs-17'>
                                            {t('t-solution2-desc').split('{appName}')[0]}
                                            <span className='fw-bold'>{appConfig.appName}</span>
                                            {t('t-solution2-desc').split('{appName}')[1]}
                                        </p>
                                        <div className="mt-4">
                                            <Link to="#" className="btn btn-soft-success w-100">{t('t-view')}</Link>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg={4} md={6}>
                            <Card className="plan-box mb-0 h-100">
                                <CardBody className="p-4 m-2">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-1 fw-semibold">
                                                {t('t-solution3')}
                                            </h4>
                                        </div>
                                        <div className="avatar-sm">
                                            <div className="avatar-title bg-light rounded-circle text-primary">
                                                <img src={industry} alt='' className='image-fluid avatar-sm card-logo-dark'></img>
                                                <img src={industry2} alt='' className='image-fluid avatar-sm card-logo-light'></img>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mt-3'>
                                        <p className='text-center fs-17'>
                                            {t('t-solution3-desc').split('{appName}')[0]}
                                            <span className='fw-bold'>{appConfig.appName}</span>
                                            {t('t-solution3-desc').split('{appName}')[1]}
                                        </p>
                                        <div className="mt-4">
                                            <Link to="#" className="btn btn-soft-success w-100">{t('t-view')}</Link>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg={4} md={6}>
                            <Card className="plan-box mb-0 h-100">
                                <CardBody className="p-4 m-2 d-flex flex-column">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-1 fw-semibold">
                                                {t('t-solution4')}
                                            </h4>
                                        </div>
                                        <div className="avatar-sm">
                                            <div className="avatar-title bg-light rounded-circle text-primary">
                                                <img src={workers} alt='' className='image-fluid card-logo-dark' style={{ width: "2.7rem", height: "2.7rem" }}></img>
                                                <img src={workers2} alt='' className='image-fluid card-logo-light' style={{ width: "2.7rem", height: "2.7rem" }}></img>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mt-3 flex-grow-1 d-flex flex-column justify-content-between'>
                                        <p className='text-center fs-17'>
                                            {t('t-solution4-desc').split('{appName}')[0]}
                                            <span className='fw-bold'>{appConfig.appName}</span>
                                            {t('t-solution4-desc').split('{appName}')[1]}
                                        </p>
                                        <div className="mt-4">
                                            <Link to="#" className="btn btn-soft-success w-100">{t('t-view')}</Link>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg={4} md={6}>
                            <Card className="plan-box mb-0 h-100">
                                <CardBody className="p-4 m-2 d-flex flex-column">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-1 fw-semibold">
                                                {t('t-solution5')}
                                            </h4>
                                        </div>
                                        <div className="avatar-sm">
                                            <div className="avatar-title bg-light rounded-circle text-primary">
                                                <img src={clinic} alt='' className='image-fluid card-logo-dark' style={{ width: "2.3rem", height: "2.3rem" }}></img>
                                                <img src={clinic2} alt='' className='image-fluid card-logo-light' style={{ width: "2.3rem", height: "2.3rem" }}></img>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mt-3 flex-grow-1 d-flex flex-column justify-content-between'>
                                        <p className='text-center fs-17'>
                                            {t('t-solution5-desc').split('{appName}')[0]}
                                            <span className='fw-bold'>{appConfig.appName}</span>
                                            {t('t-solution5-desc').split('{appName}')[1]}
                                        </p>
                                        <div className="mt-4">
                                            <Link to="#" className="btn btn-soft-success w-100">{t('t-view')}</Link>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg={4} md={6}>
                            <Card className="plan-box mb-0 h-100">
                                <CardBody className="p-4 m-2 d-flex flex-column">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-1 fw-semibold">
                                                {t('t-solution6')}
                                            </h4>
                                        </div>
                                        <div className="avatar-sm">
                                            <div className="avatar-title bg-light rounded-circle text-white">
                                                <img src={education} alt='' className='image-fluid avatar-xs card-logo-dark'></img>
                                                <img src={education2} alt='' className='image-fluid avatar-xs card-logo-light'></img>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mt-3 flex-grow-1 d-flex flex-column justify-content-between'>
                                        <p className='text-center fs-17'>
                                            {t('t-solution6-desc').split('{appName}')[0]}
                                            <span className='fw-bold'>{appConfig.appName}</span>
                                            {t('t-solution6-desc').split('{appName}')[1]}
                                        </p>
                                        <div className="mt-4">
                                            <Link to="#" className="btn btn-soft-success w-100">{t('t-view')}</Link>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment >
    );
};

export default Solutions;